export const FEED_ROUTE = '/feed';
